import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { Permiso } from "@/shared/types/permiso";

type LoginResponse = {id:string, nombre:string, email:string, token:string, isTemporal:boolean, permisos:Permiso[], organizacionId:string, organizacionNombre:string};

async function login(request:{email:string, password:string}){
    await sleep(1000);
    const response = await api.post("auth/login", request);
    return response.data as LoginResponse;
}

async function whoami(token:string){
    await sleep(1000);
    
    const response = await api.post("auth/whoami", { token })
    if(response.data) return { ...response.data, token } as LoginResponse;
    return undefined;
}

async function setPassword(newPassword:string){
    await sleep(1000);
    await api.put("auth/password", { newPassword });
}

const AuthService = {
    login,
    whoami,
    setPassword
};

export default AuthService;